import axios from '@/libs/api.request'
var qs = require('qs');
// 获取列表数据
export const fetchTableList = (params) => {
    let data = params
    data = qs.stringify(data)
    return axios.request({
        url: '/order/order-list',
        data,
        method: 'post'
    })
};
// 获取详情
export const fetchInfo = (params) => {
    let data = params
    data = qs.stringify(data)
    return axios.request({
        url: 'order/order-info',
        data,
        method: 'post'
    })
};